import { css, TextAreaConfig, media, tokens } from '@sail/ui';
export const textAreaCustomization = TextAreaConfig.customize({
    uses: [
        css({
            gridTemplateColumns: '1fr',
            gridTemplateRows: 'auto',
            [media.up(tokens.viewport.small)]: {
                gridTemplateColumns: '1fr 2fr'
            }
        }),
        css({
            gapX: 'large',
            gapY: 'small'
        })
    ],
    subviews: {
        inputs: {
            uses: [
                css({
                    gridColumn: '0 / 1',
                    alignSelf: 'stretch',
                    [media.up(tokens.viewport.small)]: {
                        gridColumn: '2 / 3',
                        gridRow: '1 / 3'
                    }
                })
            ]
        },
        input: {
            uses: [
                css({
                    height: '100%'
                })
            ]
        },
        description: {
            uses: [
                css({
                    alignSelf: 'start'
                })
            ]
        },
        error: {
            uses: [
                css({
                    gridArea: 'inherit',
                    [media.up(tokens.viewport.small)]: {
                        gridArea: '3/2'
                    }
                })
            ]
        }
    }
});

//# sourceMappingURL=textArea.js.map